export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_07-7c99d6a78fb126995d9453a80c6c77e2.png";